import React, {useCallback, useContext, useState} from "react";
import Button from "@mui/material/Button";
import Form from "./Form";
import {HomeAppContext} from "../../../Home";
import api from "../../../../Services/api";
import {errorManagement} from "../../../../Services/errorManagement";
import moment from "moment-timezone";
import GenericDialog from "../../../GenericDialog";

export default function Edit({ open, setOpen, entry, onEdit }) {
  const { homeDispatch } = useContext(HomeAppContext);
  const [errors, setErrors] = useState([]);

  const [internalEntry, setInternalEntry] = useState(null);
  const [loading, setLoading] = useState(false);

  const getEntry = useCallback(() => {
    if (entry !== null) {
      setLoading(true);
      api
        .get(`/api/system/notifications/${entry.id}`)
        .then((r) => {
          setInternalEntry({
            ...r.data,
            time: moment.tz(r.data.time, "HH:mm:ss", r.data.timezone),
          });
          setErrors([]);
          setLoading(false);
        })
        .catch((error) => {
          errorManagement.formErrors(error, homeDispatch);
        });
    }
  }, [entry, homeDispatch]);

  React.useEffect(() => {
    if (open) getEntry();
  }, [getEntry, open]);

  const handleClose = () => {
    setOpen(false);
    setInternalEntry(null);
    setLoading(true);
  };

  const handleCloseSave = () => {
    const updateEntry = {
      ...internalEntry,
      time: internalEntry.time.format("HH:mm:ss"),
    };

    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Updating Notification", loading: true },
    });
    setLoading(true);
    api
      .put(`/api/system/notifications/${updateEntry.id}`, updateEntry)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: { message: "Notification updated", type: "success" },
        });
        setOpen(false);
        setLoading(false);
        if (onEdit) onEdit();
      })
      .catch((error) => {
        setLoading(false);
        errorManagement.formErrors(error, homeDispatch, setErrors);
      });
  };
  const actions = (
    <>
      <Button onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={handleCloseSave}
        color="primary"
        autoFocus
        disabled={loading}
      >
        Save
      </Button>
    </>
  )
  return internalEntry === null ? null : (
    <GenericDialog
      fullWidth
      maxWidth={"sm"}
      open={open}
      onClose={handleClose}
      title={"Edit Notification"}
      actions={actions}
    >
        <Form
          entry={internalEntry}
          errors={errors}
          setEntry={setInternalEntry}
          loading={loading}
        />
    </GenericDialog>
  );
}
